import styled from 'styled-components';
import { motion } from 'framer-motion';
import {
  FaGithub,
  FaTwitter,
  FaLinkedin,
  FaHeart,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaInstagram,
} from 'react-icons/fa';

const FooterSection = styled.footer`
  background: rgba(10, 12, 20, 0.92);
  backdrop-filter: blur(10px);
  padding: 60px 20px 24px;
  color: white;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 40px;
  margin-bottom: 32px;
`;

const FooterColumn = styled(motion.div)`
  display: flex;
  flex-direction: column;
`;

const FooterTitle = styled.h4`
  font-size: 1.15rem;
  font-weight: 800;
  margin-bottom: 16px;
  letter-spacing: 0.2px;
  color: #667eea; /* marka vurgusu */
`;

const P = styled.p`
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.7;
  font-size: 0.98rem;
`;

const Badge = styled.span`
  display: inline-block;
  margin-top: 10px;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 0.75rem;
  background: rgba(102, 126, 234, 0.15);
  color: #b2bdfc;
  border: 1px solid rgba(102, 126, 234, 0.25);
`;

const FooterLink = styled.a`
  color: rgba(255, 255, 255, 0.82);
  margin-bottom: 10px;
  font-size: 0.96rem;
  text-decoration: none;
  transition: color 0.25s ease;
  &:hover {
    color: #8aa5ff;
  }
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.82);
  margin-bottom: 10px;
  svg {
    flex: 0 0 auto;
    opacity: 0.85;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 14px;
  margin-top: 12px;
`;

const SocialLink = styled.a`
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.3rem;
  transition: transform 0.25s ease, color 0.25s ease;
  &:hover {
    color: #8aa5ff;
    transform: translateY(-2px);
  }
`;

const Line = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  margin: 8px 0 16px;
`;

const FooterBottom = styled.div`
  padding-top: 10px;
  text-align: center;
  color: rgba(255, 255, 255, 0.65);
  display: grid;
  gap: 8px;
  justify-items: center;
`;

const BottomLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  a {
    color: rgba(255, 255, 255, 0.72);
    font-size: 0.92rem;
    text-decoration: none;
  }
  a:hover {
    color: #b2bdfc;
  }
`;

const HeartIcon = styled(FaHeart)`
  color: #e74c3c;
  animation: beat 1.5s ease-in-out infinite;
  @keyframes beat {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
  }
`;

export const Footer = () => {
  return (
    <FooterSection>
      <Container>
        <FooterBottom>
          <div>
            <strong>Altın Yazılım © 2025.</strong> | info@altinyazilim.com - +90 216 4497049
          </div>
        </FooterBottom>
      </Container>
    </FooterSection>
  );
};
